export default __webpack_public_path__ + "fba3dd5ad342e858200c50bdb85c0ff5.png";